import React from "react";
import MUIContainer from "@material-ui/core/Container";
import { ContainerProps } from "@material-ui/core/Container/Container";

const Container = (props: ContainerProps) => {
	return <MUIContainer {...props} />;
};

export { Container };
